import { COMMON_MIXPANEL_EVENTS, COMMON_MIXPANEL_PAGE } from '../../common/constants/mixpanelConstants'
import { UTM_CAMPAIGN } from '../../common/constants/utm'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const electionMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.ELECTION,
  iFrameSrcUrl: '/election-microsite',
  micrositeUrl: 'election',
  title: {
    id: 'electionMicrosite.title',
    defaultMessage: 'Election resources',
    description: 'Microsite page title for election resources',
  },
  featureFlag: 'isElectionsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: COMMON_MIXPANEL_PAGE.ELECTION_STRESS_TOOLKIT,
  trackUTMParams: {
    utm_campaign: UTM_CAMPAIGN.ELECTION,
  },
  shouldHideForInternational: true,
  usePageForViewEvent: true,
  viewEventPage: 'election stress toolkit page',
  trackEntryPoint: true,
  errorEvent: COMMON_MIXPANEL_EVENTS.ELECTION_ERROR,
}
